'use client';

import { forwardRef } from 'react';

import { NumberInput as MantineNumberInput, type NumberInputProps } from '@mantine/core';

export interface INumberInput extends NumberInputProps {
  dataTestId?: string;
}

export const NumberInput = forwardRef<HTMLInputElement, INumberInput>(({ dataTestId, ...props }, ref) => (
  <MantineNumberInput data-testid={dataTestId} ref={ref} {...props} />
));

NumberInput.displayName = 'NumberInput';
